import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TenantLocalService } from '../services/api/tenantlocal.service';

@Injectable()
export class AuthTenantInterceptor implements HttpInterceptor {
  constructor(private tenantService: TenantLocalService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const tenant = this.tenantService.tenantSlug;

    // Armamos headers solo si existen:
    let headers = req.headers;
    if (tenant) {
      headers = headers.set('tenant-id', tenant.toString());
    }

    // Clonamos la request SIN tocar Content-Type → respeta boundary
    const authReq = req.clone({ headers });

    return next.handle(authReq);
  }
}
